import helper from '../../helper';

export default {
	state: {
		invoicingNumbers: {
			loading: false,
			data: {
				kp_bh_list: [],
			},
		},
	},
	mutations: {
		requestNumber(state) {
			state.invoicingNumbers.loading = true;
		},
		successNumber(state, data) {
			state.invoicingNumbers.loading = false;
			state.invoicingNumbers.data = data;
		},
		resetNumber(state) {
			state.invoicingNumbers.loading = false;
			state.invoicingNumbers.data = {
				kp_bh_list: [],
			};
		},
	},
	actions: {
		async getInvoicingNumber({ commit }, params) {
			return helper(this, async () => {
				commit('requestNumber');
				const res = await a.api('getSpBh', params);
				commit('successNumber', res.result);
			});
		},
	},
};
